var loadServices;


$(function () {
    loadServices = {

        page: 1,
        state: initState,
        loading: false,
        finished: false,
        textSearch: textSearch,
        category: category,

        loadNext: function () {
            loadServices.page = loadServices.page + 1;
            loadServices.load();
        },

        fnFormataUrl: function(site, linkedin){
          var url = "#";
          if (linkedin != "") url = "/redirect/linkedin/?url="+linkedin;
          if (site != "") url = "/redirect/website/?url="+site;
          return url;
        },

        analytics: function(){
          let loadingElements = document.getElementsByClassName('loading');
          if (typeof gtag === "function" && loadingElements.length > 0) {
              gtag('event', 'page_view', {
                  'event_category': 'service',
                  'event_label': 'Page ' + loadServices.page,
                  'value': 1
              });
          }
        },

        load: function () {
            if (loadServices.finished) return;
            $(".loading").fadeIn();
            loadServices.loading = true;

            let url = loadServices.textSearch == "" ?
              `/api/v1/services/${loadServices.page}/${loadServices.state}` :
              `/api/v1/services/${loadServices.page}/${loadServices.state}/${loadServices.textSearch}`;
            if(loadServices.category) url += `?category=${loadServices.category}`;

            $.ajax({
                dataType: "json",
                url: url,
                success: function (req) {

                    if (req[1].services.length == 0) {
                      loadServices.finished = true;
                    } else {
                      //Advertising
                      if (loadServices.page > 1){
                        let ad = req[0].advertising[0];
                        let ad_template = `<div class="cell large-12 ultra-banner">
                                        <div class="desktop"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_desktop}" /></a></div>
                                        <div class="mobile"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_mobile}" /></a></div>
                                        </div>`;
                        $("#topicos-container").append(ad_template);
                        $.get(`/api/advertising-views/${ad.id}/`)
                      }
                      //Companies
                        $(req[1].services).each(function (ix, x) {
                            let template = `
                              <div class="grid-x grid-padding-x topico">
                                <div class="cell large-2 topico-avatar">
                                  <img src="/api/v1/diminuator?file=img/companies/${x.imagem_local}&w=150&h=150" alt="${x.nome_da_empresa}">
                                </div>
                                <div class="cell large-10 topico-conteudo">
                                  <div class="category">${x.descricao}</div>
                                  <h2>${x.nome_da_empresa}</h2>
                                  <div class="spacer-10"></div>
                                  ${(x.site) ? `<div class="site"><strong>Site:</strong> <a href="/redirect/website/?url=${x.site}" rel="nofollow" target="_blank">${x.site}</a></div>` : ``}
                                  ${(x.telefone) ? `<div class="telefone"><strong>Telefone:</strong> ${x.telefone}</div>` : ``}
                                  ${(x.endereco) ? `<div class="endereco"><strong>Endereço:</strong> ${x.endereco}</div>` : ``}
                                  ${(x.cidade || x.estado) ? `
                                    <div class="spacer-10"></div>
                                    <div class="estado">
                                      <strong>Local: </strong>
                                        ${x.cidade ? x.cidade:''}
                                        ${(x.cidade && x.estado)?' / ':''}
                                        ${x.estado ? x.estado:''}
                                    </div>` :
                                  ``}
                                </div>
                              </div>`
                            $("#topicos-container").append(template);
                        })
                    }
                    $(".loading").fadeOut();
                    loadServices.analytics();
                    loadServices.loading = false;
                }
            });
        },

        search: function(div){
          var search = $(`.search-form.${div} #searchText`).val().toString();
          if(!search){
              document.location.href = `/servicos/`;
          } else if(search && loadServices.state && loadServices.state != "all") {
              document.location.href = `/servicos/${loadServices.state}/${search}/`;
          } else {
            document.location.href = `/servicos/${search}/`;
          }
        }
    }

    $(".search-form.desktop .icon").click(function(){
      $(".search-form .form").animate({width:'toggle'},350);
      $("#searchText").focus();
    });

    $(".search-form.desktop #btnOk").click(function(){ loadServices.search('desktop'); });
    $(".search-form.mobile #btnOk").click(function(){ loadServices.search('mobile'); });

    $(".search-form.desktop #searchText").on('keypress',function(e) {
      if(e.which == 13) $(".search-form.desktop #btnOk").click()
    });

    if(textSearch){
      $(".search-form.desktop #searchText,.search-form.mobile #searchText").val(textSearch)
      $(".search-form").addClass("search")
    }

    window.onscroll = function(ev) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    if (scrollTop + windowHeight >= documentHeight - 100) {
      if (loadServices.loading === false) {
        loadServices.loadNext();
      }
      $('#back-to-top').addClass('visible');
    } else {
      if (scrollTop != 0) {
        $('#back-to-top').addClass('visible');
      } else {
        $('#back-to-top').removeClass('visible');
      }
    }

  };

  $(".forum.services .categorias h3").click(function() {
    $(".forum.services .categorias ul").fadeIn();
  });

  $("#back-to-top").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow", function() {
      $('#back-to-top').removeClass('visible');
    });
  });

})
